import { render, staticRenderFns } from "./Minute.vue?vue&type=template&id=67d58395"
import script from "./Minute.vue?vue&type=script&lang=js"
export * from "./Minute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports